import React from 'react';
import { motion } from 'framer-motion';
type Direction = 'up' | 'down' | 'left' | 'right';
interface FadeInProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  direction?: Direction;
}
const offsets: Record<Direction, {
  x: number;
  y: number;
}> = {
  up: {
    x: 0,
    y: 24
  },
  down: {
    x: 0,
    y: -24
  },
  left: {
    x: 24,
    y: 0
  },
  right: {
    x: -24,
    y: 0
  }
};
export function FadeIn({
  children,
  className,
  delay = 0,
  direction = 'up'
}: FadeInProps) {
  const offset = offsets[direction];
  return <motion.div className={className} initial={{
    opacity: 0,
    x: offset.x,
    y: offset.y
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.25, 0.1, 0.25, 1]
  }} data-id="element-8">
      {children}
    </motion.div>;
}